"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CarFront.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CarFront = function CarFront(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 196 147"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Car Front Icon"), _react2.default.createElement("g", {
    className: "car",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "chasis",
    d: "M177.1 54.7L196 43.4l-4.6-6.6-19.2 11.4L151.9 0H44.2L23.8 48.2 4.6 36.8 0 43.4l18.9 11.3C11.2 57.9 5.8 65.1 5.8 73.4V101c0 10.1 7.9 18.5 18.2 20.2v6.9c0 10.4 9.2 18.9 20.4 18.9s20.4-8.5 20.4-18.9v-6.5H131v6.5c0 10.4 9.2 18.9 20.4 18.9s20.4-8.4 20.4-18.9v-6.9c6.5-1 12.3-4.9 15.6-10.7 1.7-2.9 2.6-6.2 2.6-9.6V73.4c.2-8.3-5.2-15.5-12.9-18.7zM50 7.9h43.8V23h8.5V7.9h43.8l19 44.9H31L50 7.9zm6.4 120.2c0 6.1-5.3 11-11.9 11s-11.9-4.9-11.9-11v-6.5h23.8v6.5zm95.2 11c-6.6 0-11.9-4.9-11.9-11v-6.5h23.9v6.5c-.1 6.1-5.4 11-12 11zm30.1-38.1c0 2.1-.5 4.1-1.6 5.9-2.6 4.3-7.2 6.9-12.2 6.8H28.1c-7.6 0-13.8-5.7-13.8-12.7V73.4c0-7 6.2-12.7 13.8-12.7h139.8c7.6 0 13.8 5.7 13.8 12.7V101z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "headlamps",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "headlamp",
    d: "M154.9 73.2c-9.4 0-17.1 7.1-17.1 15.8.1 6.6 4.3 12.4 10.5 14.6 2.1.8 4.4 1.2 6.7 1.2 6 .1 11.7-3 14.9-8.1 1.4-2.3 2.2-5 2.2-7.8-.1-8.6-7.8-15.7-17.2-15.7zm7.5 19.7c-2.4 3.5-6.9 4.9-10.9 3.4-3.1-1.1-5.2-4-5.3-7.3 0-4.4 3.9-8 8.6-8s8.6 3.6 8.6 8c.1 1.4-.3 2.7-1 3.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "headlamp-2",
    d: "M41.2 73.2C31.7 73.2 24 80.3 24 89s7.7 15.8 17.1 15.8S58.3 97.7 58.3 89s-7.7-15.8-17.1-15.8zm0 23.8c-4.8 0-8.6-3.6-8.6-8s3.9-8 8.6-8 8.6 3.6 8.6 8-3.9 8-8.6 8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: undefined
  })), _react2.default.createElement("path", {
    className: "grill",
    d: "M82.5 85.1h31.1V93H82.5v-7.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: undefined
  })));
};
exports.default = CarFront;